import { render, staticRenderFns } from "./DoKoBtn.vue?vue&type=template&id=2bc1c470&"
import script from "./DoKoBtn.vue?vue&type=script&lang=ts&"
export * from "./DoKoBtn.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports